<template>
  <section id="upload-list" class="">
    <v-card
      v-show="
        this.$store.getters.uploads_show &&
          this.$store.getters['reports/getUploadsLength'] > 0
      "
    >
      <v-card-actions>
        <v-icon @click="close" dark class="close">close</v-icon>
      </v-card-actions>

      <div v-if="uploading" class="resource">
        <div>
          {{ $t('general.resource') }} <span class="name">{{ uploading.name }}</span>
        </div>
        <div class="file">
          <div class="label">
            {{ $t('general.file') }}
            <span class="value">{{ uploading.file_upload | percent }}</span>
          </div>
          <v-progress-linear
            v-model="uploading.file_upload"
            color="#FFBB0C"
            :indeterminate="file_current(uploading)"
          ></v-progress-linear>
        </div>
      </div>
      <div v-for="(item, index) in pullUploads" class="resource">
        <div>
          {{ $t('general.resource') }} <span class="name">{{ item.name }}</span>
        </div>
        <div class="file">
          <div class="label">
            {{ $t('general.file') }} <span class="value">{{ item.file_upload | percent }}</span>
          </div>
          <v-progress-linear
            v-model="item.file_upload"
            color="#FFBB0C"
            :indeterminate="file_current(item)"
          ></v-progress-linear>
        </div>
      </div>
    </v-card>
  </section>
</template>

<script>
import i18n from '@/i18n';
export default {
  props: {},
  components: {},
  data() {
    return {
      uploadings: []
    };
  },
  computed: {
    market() {
      return this.$store.getters["getMarket"];
    },
    uploading() {
      return this.$store.getters["reports/getUploading"];
    },
    pullUploads() {
      return this.$store.getters["reports/getPullUploads"];
    }
  },
  methods: {
    close() {
      this.$store.commit("showUploads", false);
    },
    file_current(resource) {
      if (typeof resource.file_upload !== "undefined") {
        return false;
      }
      return true;
    }
  },
  mounted() {},
  created() {},
  filters: {
    percent: function(num) {
      if (typeof num === "undefined") return i18n.t('general.waiting');
      else if (num < 100) return num + " %";
      return i18n.t('general.uploaded');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#upload-list .v-card {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 30%;
  border: 1px solid #000;
  min-height: 150px;

  .v-card__actions {
    background-color: rgba(0, 0, 0, 0.8);
    float: right;
    width: 100%;
    margin-bottom: 10px;

    .close {
      float: right;
    }
  }

  .resource {
    text-align: left;
    padding: 5px 10px;

    .name {
      font-size: 16px;
      font-weight: bold;
    }

    .value {
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>
